// Copyright 2022, Imprivata, Inc.  All rights reserved.

type EnvFeatureFlags<T> = { global: T } & Partial<Record<string, Partial<T>>>;

/**
 * Resolves feature flags for a tenant: tenant overrides take precedence, anything
 * not overridden falls back to the environment's global flags.
 */
export function resolveFeatureFlags<T>(envFlags: EnvFeatureFlags<T>, tenantId: string | null): T {
  const tenantFlags = tenantId ? envFlags[tenantId] : undefined;
  return { ...envFlags.global, ...tenantFlags };
}
